import { Progress as UIProgress } from "../ui/progress";

type Props = React.ComponentProps<typeof UIProgress>;

export default function Progress({ className, value, ...props }: Props) {
  return (
    <UIProgress
      {...props}
      value={value}
      className={`rounded-none h-1 ${className}`}
    />
  );
}
